import { Box, IconClear, IconSearch, Strong, Text } from 'braid-design-system';

import * as styles from './DismissableTooltip.css';

interface TooltipProps {
  handleClose: () => void;
  message: string;
}

export const DismissableTooltip = ({ handleClose, message }: TooltipProps) => (
  <Box position="absolute" width="full" paddingTop="medium" zIndex="dropdown">
    <Box
      borderRadius="large"
      paddingX="small"
      paddingY="xsmall"
      background="info"
      display="flex"
      justifyContent="spaceBetween"
      alignItems="center"
    >
      <Box display="flex" alignItems="center">
        <Box>
          <IconSearch tone="secondary" />
        </Box>
        <Box paddingX="xsmall">
          <Text size="xsmall" baseline={false}>
            <Strong>{message}</Strong>
          </Text>
        </Box>
      </Box>
      <Box cursor="pointer" onClick={handleClose}>
        <IconClear />
      </Box>
      <Box className={styles.arrow} />
    </Box>
  </Box>
);
